import { Button, Image, Modal, UIHeading1, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';
import { IconFunctionalSuccessCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';
import styles from './styles.css';
import QualityImg from './assets/quality.png';
import {
  QUALITY_CRITERIA_LIST,
  QUALITY_CRITERIA_MODAL_TITLE,
} from '../../containers/SelectBestAgentContainer/constants';
import { clsx } from 'clsx';

interface IQualityCriteriaModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const QualityCriteriaModal: FC<IQualityCriteriaModalProps> = ({ isOpen, handleClose }) => {
  const device = useDeviceType();
  const isMobile = device === 'phone';
  const Title = isMobile ? UIHeading2 : UIHeading1;

  return (
    <Modal
      open={isOpen}
      onOpenChange={handleClose}
      footer={
        <div className={clsx(styles['quality-criteria_footer'], styles[device])}>
          <Button onClick={handleClose} fullWidth={isMobile}>
            Круто!
          </Button>
        </div>
      }
    >
      <div className={styles['container']}>
        <div className={styles['quality-criteria_image']}>
          <Image src={QualityImg} />
        </div>
        <div className={clsx(styles['quality-criteria_content'], styles[device])}>
          <Title>{QUALITY_CRITERIA_MODAL_TITLE}</Title>
          <div className={styles['quality-criteria_list']}>
            {QUALITY_CRITERIA_LIST.map((criteria, index) => (
              <div key={index} className={styles['quality-criteria_item']}>
                <div className={styles['quality-criteria_icon']}>
                  <IconFunctionalSuccessCircle16 color="icon-positive-default" width={16} height={16} />
                </div>
                <UIText1>{criteria}</UIText1>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};
